import React            from 'react';

import DateRangeReport  from 'Manager/components/DateRangeReport';
import BoardingsTable   from 'Manager/components/BoardingsTable';

export default class Boardings extends DateRangeReport {
    getTitle() : (string|React.ReactNode) {
        const urlSearchParams = new URLSearchParams({
            csv    : '1',
            min_ts : this.state.min_ts,
            max_ts : this.state.max_ts
        });
        return (
            <React.Fragment>
                Boardings from {this.state.min_ts} to {this.state.max_ts}
                <a key='download' href={`/api/manager/report/boardings?${urlSearchParams.toString()}`}><i className="fa fa-download"/></a>
            </React.Fragment>
        );
    }
    getTable() : React.ReactNode {
        const getTablePromiseArgs = ( orderby:string, limit:number, skip:number ) => {
            return [
                '/api/manager/report/boardings',
                'GET',
                undefined,
                {
                    min_ts   : this.state.min_ts,
                    max_ts   : this.state.max_ts,
                    orderby,
                    limit,
                    skip
                }
            ];
        }
        return <BoardingsTable min_ts={this.state.min_ts} max_ts={this.state.max_ts} getTablePromiseArgs={getTablePromiseArgs}/>;
    }
}